module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add financial field","key":"Key","value":"Value"},"et":{"title":"Add financial field","key":"Key","value":"Value"},"ru":{"title":"Add financial field","key":"Key","value":"Value"}}')
  delete Component.options._Ctor
}
